// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"90":"cf1ca3da","109":"5058d93e","118":"c7445891","663":"c7445891","811":"c7445891","982":"c7445891"}[chunkId] + ".chunk.css";
};